export function effectiveBoxUnits(box) {
  return Number(
    box?.amendedUnits ??
      box?.handCountUnits ??
      box?.receivedUnits ??
      box?.scannedUnits ??
      0,
  ) || 0;
}

export function flattenReceivingBoxes(pos = []) {
  return pos.flatMap((po) =>
    (po.boxes || []).map((box) => ({
      id: `${po.id}:${box.id}`,
      poId: po.id,
      poDbId: po.poDbId,
      poNumber: po.id,
      supplier: po.supplier || 'Unknown',
      boxId: box.id,
      boxNumber: box.boxNumber,
      productId: box.productId,
      sku: box.sku || '—',
      productName: po.lineItems?.find((line) => line.sku === box.sku)?.productName || box.sku || '—',
      expectedUnits: Number(box.expectedUnits) || 0,
      existingUnits: effectiveBoxUnits(box),
      receivedUnits: Number(box.receivedUnits) || 0,
      scannedUnits: Number(box.scannedUnits) || 0,
      state: box.state || 'pending',
      inboundType: box.inboundType,
      box,
    })),
  );
}

export function rowEnteredUnits(row) {
  if (row?.epcs?.length) return row.epcs.length;
  if (row?.inputQty !== '' && row?.inputQty != null) return Number(row.inputQty) || 0;
  return 0;
}

export function summarizeBulkRows(rows = []) {
  const enteredRows = rows.filter((row) => rowEnteredUnits(row) > 0);
  const expectedUnits = rows.reduce((sum, row) => sum + row.expectedUnits, 0);
  const enteredUnits = rows.reduce((sum, row) => sum + rowEnteredUnits(row), 0);
  return {
    totalBoxes: rows.length,
    enteredBoxes: enteredRows.length,
    expectedUnits,
    enteredUnits,
    variance: enteredUnits - expectedUnits,
  };
}

export function bulkRowAction(row) {
  if (row?.epcs?.length) return 'captureScan';
  if (row?.existingUnits > 0 || row?.scannedUnits > 0) return 'overrideReceiveBox';
  return 'manualReceiveBox';
}

export function isBulkRowOverExpected(row) {
  return rowEnteredUnits(row) > Number(row?.expectedUnits || 0);
}

export function overExpectedBulkRows(rows = []) {
  return rows.filter(isBulkRowOverExpected);
}

export function bulkDraftKey(poIds = []) {
  return `eadin:receiving-bulk-draft:v1:${[...poIds].map(String).sort().join(',')}`;
}
